<template>
  <div class="language">
    <p>
      <router-link
        :to="path"
        data-hover="link"
      >{{locale === 'it' ? 'English Version' : 'Versione Italiana'}}</router-link>
    </p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      toWorks: {
        it: "/it/cosa",
        en: "/en/what"
      }
    };
  },
  methods: {
    changeLanguage(language) {
      if (this.$route.name === "home") {
        this.$router.push({
          name: "home",
          params: {
            locale: language
          }
        });
      } else if (this.$route.name === "work") {
        this.$router.push(
          this.toWorks[language] +
            "/" +
            this.$store.getters.getWorkSlugByLocale(language)
        );
      } else if (this.$route.name === "page") {
        this.$router.push({
          name: this.$route.name,
          params: {
            locale: language,
            page: this.$store.getters.getPageSlugByLocale(language)
          }
        });
      } else if (this.$route.name === "cosa") {
        this.$router.push(this.toWorks[language]);
      }
    }
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },

    path() {
      let lang = "";
      this.locale === "it" ? (lang = "en") : (lang = "it");
      if (this.$route.name === "home") {
        return {
          name: "home",
          params: {
            locale: lang
          }
        };
      } else if (this.$route.name === "work") {
        return (
          this.toWorks[lang] +
          "/" +
          this.$store.getters.getWorkSlugByLocale(lang)
        );
      } else if (this.$route.name === "page") {
        return {
          name: this.$route.name,
          params: {
            locale: lang,
            page: this.$store.getters.getPageSlugByLocale(lang)
          }
        };
      } else if (this.$route.name === "cosa") {
        return this.toWorks[lang];
      }
    }
  }
};
</script>


<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";
.language {
  p {
    text-align: right;
    @include breakpoint(medium down) {
      text-align: center;
    }
    a {
      font-weight: bold;
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
